import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const BackgroundIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.018 16.515a.936.936 0 0 0 .935-.936V9.497a3.747 3.747 0 0 0-3.742-3.743h-1.965V3.743A3.747 3.747 0 0 0 14.503 0H3.743A3.747 3.747 0 0 0 0 3.743v10.76a3.747 3.747 0 0 0 3.743 3.743h1.965v2.011A3.747 3.747 0 0 0 9.45 24h10.76a3.747 3.747 0 0 0 3.743-3.743.936.936 0 0 0-1.871 0c0 1.032-.84 1.872-1.871 1.872H9.45a1.873 1.873 0 0 1-1.872-1.872V9.497c0-1.032.84-1.871 1.871-1.871h10.76c1.032 0 1.872.84 1.872 1.871v6.082c0 .517.419.936.936.936zM1.87 3.743c0-1.032.84-1.872 1.872-1.872h1.329l-3.2 3.2V3.744zm3.837 12.631H3.89l1.818-1.817v1.817zm0-6.877v2.413l-3.564 3.564a1.86 1.86 0 0 1-.273-.971v-1.47l3.85-3.85a3.805 3.805 0 0 0-.013.314zm-3.837.89V7.718l5.84-5.84a.898.898 0 0 0 .008-.007h2.668L1.87 10.387zm9.993-4.633H9.45c-.105 0-.21.005-.313.013l3.665-3.664a.935.935 0 0 0 .17-.232h1.53c.356 0 .689.1.972.273L11.876 5.74a.853.853 0 0 0-.012.013zm4.51 0H14.51l1.864-1.864v1.864z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

BackgroundIcon.propTypes = propTypes;

export default BackgroundIcon;
